import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { CityPill } from "@/components/dm/CityPicker";
import { Feed, FilterBar } from "@/components/dm/Feed";
import { Waitlist } from "@/components/dm/EmptyState";
import { SearchBar } from "./Home";

export default function Explore() {
  const { t, hub, ready, areasOf, L } = useApp();
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [f, setF] = useState({ category: params.get("category") || "", type: "", status: "active", area: "", side: "" });
  const set = (p) => setF((s) => ({ ...s, ...p }));
  useEffect(() => { setF((s) => ({ ...s, area: "", side: "" })); }, [hub?.id]);
  if (!ready || !hub) return null;
  const isOG = hub.id === "ottawa-gatineau";
  const areas = areasOf(hub.id).filter((a) => !f.side || a.side === f.side);
  return (
    <div className="max-w-6xl mx-auto px-4 py-6 space-y-5">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">{t("explore")}</h1>
      <div className="flex flex-wrap items-center gap-3"><CityPill /><SearchBar autoFocus initial={q} onSubmit={(v) => setParams(v ? { q: v } : {})} /></div>
      {hub.launch_status !== "active" ? <Waitlist hub={hub} /> : (<>
        <FilterBar f={f} set={set} />
        <div className="flex flex-wrap gap-2">
          {isOG && (
            <div className="flex rounded-full bg-[#F3EDE4] p-1" role="group">
              {[["", "both_sides"], ["ottawa", "ottawa_side"], ["gatineau", "gatineau_side"]].map(([v, k]) => (
                <button key={k} data-testid={`side-filter-${v || "both"}`} aria-pressed={f.side === v} onClick={() => set({ side: v, area: "" })}
                  className={`press min-h-[40px] px-4 rounded-full text-sm font-bold ${f.side === v ? "bg-[#1E4D3B] text-white" : "text-[#6B5E55]"}`}>{t(k)}</button>
              ))}
            </div>
          )}
          <select data-testid="area-filter" value={f.area} onChange={(e) => set({ area: e.target.value })} aria-label={t("area")}
            className="min-h-[48px] rounded-full border border-[#E8E2D9] bg-[#FFFDF9] px-4 text-sm font-semibold">
            <option value="">{t("any_area")}</option>
            {areas.map((a) => <option key={a.id} value={a.id}>{L(a)}</option>)}
          </select>
        </div>
        <Feed hub={hub} filters={{ ...f, q }} />
      </>)}
    </div>
  );
}
